import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import {Link} from 'react-router-dom'
import { BsFlag } from "react-icons/bs";
import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import styles from './View.Style'
import { formatDateToShortMonth } from '../ChallengeDetails/View';

const useStylesChallenge = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  grid3block: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gap:'1rem',
    margin:'2rem 0',
  },
  title:{
    fontFamily: 'VodafoneRg-bold', 
    fontSize: '2.125rem',
    margin: '1rem 0 2rem 0', 
    textAlign: 'left',
    paddingTop: '1rem',
    color:theme.palette.primary.main,
  },
  textsmall:{
    fontFamily: 'VodafoneRg-bold', 
    margin: '0 8px 0 0', 
    fontSize: '1rem',
    textAlign: 'left',
    color:theme.palette.headerText.main,
    display:'block',
    lineHeight:'1.4',
    background: theme.palette.primary.dark,
    borderRadius: '1rem',
    padding: '2px 1rem'
},
  filterContainer:{
    display:'flex',
    alignItems:'center'
  },

  filterSelect:{
    fontFamily: 'VodafoneRg-bold', 
    fontSize: '1rem',
    backgroundColor: 'transparent',
    border: '1px solid',
    borderColor:theme.palette.primary.light,
    padding: '6px',
    borderRadius: '2rem' 
  }

}));

const AllChallenge = (props) => {
  const classes = useStylesChallenge();
   const {getInnovateChallengeAllListFn ,listInnovateChallenge,innovateCategoryTypes,getInnovateChallengeActiveTypesFn,onEditClick,isAdmin} = props || {}
  const [challengeStatus, setChallengeStatus] = React.useState('ACTIVE')
  const listInnovateChallengeData = listInnovateChallenge?.data

    React.useEffect(()=>{
        getInnovateChallengeAllListFn()
        getInnovateChallengeActiveTypesFn()
    },[])

  const handleFilterChange = event => {
    const status = event.target.value
    setChallengeStatus(status)
}
  return (
    <Container >
      <h2 className={classes.title}>All Challenge </h2>

          <div className={classes.filterContainer}>
              <span className={classes.textsmall}> Filter </span>
              <form>
                  <select
                      value={challengeStatus}
                      onChange={handleFilterChange}
                      className={classes.filterSelect}
                  >
                      <option value="ACTIVE">Active Challenge</option>
                      <option value="MYCHALLENGE">My Challenge</option>
                      <option value="FINISHED">Close Challenge</option>
                  </select>
              </form>
          </div>

    <div className={classes.grid3block} >
        {
          listInnovateChallengeData?.map((singleChallengeItem)=>{
           const {id,title,ideas,ends,categoryTypeId,sponsorEmail,creatorEmail,status} = singleChallengeItem
           const endDataFormat = formatDateToShortMonth(ends?.dateString)

           const selectedType = innovateCategoryTypes.find(
            (type) => +type.id === +categoryTypeId
          );
          
          // {selectedType && <p className={classes.text}>{selectedType.name}</p>}
          
            return (
              <SingleChallegeComponent
              passAllDataToDetails={singleChallengeItem}
              key={id}
              redirectLinkId={id}
              ideaSubmitted={ideas?.lenght || 0 }
              challengeTitle={title}
              challengeOwner={creatorEmail || sponsorEmail}
              submissionsEnd={endDataFormat}
              category={selectedType?.name}
              status={status}
              onEditClick={onEditClick}
              onlyAdminEdit={isAdmin}
            />  
            )
          })
        }

    </div>

    </Container >
  )
}

export default withStyles(styles)(AllChallenge)








const useSingleChallegeComponentStyles = makeStyles((theme) => (
    
    {
    root: {
      width: '100%',
    },
    headingbox:{
        backgroundColor: 'rgba(230, 0, 1, 0.09)',
        borderRadius: '0.5rem',
        padding: '1rem',
        boxSizing: 'border-box',
        marginBottom:'0rem',
        height:'100%',
    },
    headingIcon:{
        backgroundColor: 'rgba(230, 0, 1, 0.05)',
        padding: '4.5px',
        borderRadius: '50%',
        boxSizing: 'border-box',
        margin: '0 0 0.5rem 0 ',
        lineHeight: '0',
        height: '25px',
        width: '25px',
        display: 'inline-block',
    },
    fieldrow:{
        borderBottom: '1px solid #ccc',
        padding: '1rem 0',
        display: 'grid',
        gridTemplateColumns: '40% 1fr',
        gap: '1rem'
    },
    title:{
        fontFamily: 'VodafoneRg-bold', 
        fontSize: '1.5rem',
        margin: '0.5rem 0', 
        textAlign: 'left',
        paddingTop: '0rem',
        color:'#333',
      },
    textsmall:{
        fontFamily: 'VodafoneRg-regular', 
        margin: '0 0 0 0', 
        fontSize: '0.9rem',
        textAlign: 'left',
        color:'#333',
        display:'block',
        lineHeight:'1.4'
    },
    alignbtn:{
        display:'flex',
        alignItems:'center',
        gap:'1rem'
    },
    selectbtn:{
        margin:'1rem 0 0',
        color: '#fff',
        border: '1px solid',
        display: 'block',
        padding: '0.5rem',
        fontSize: '1rem',
        boxSizing: 'border-box',
        textAlign: 'center',
        transition: 'all 300ms ease',
        fontFamily: 'VodafoneRg-Regular',
        borderRadius: '5px',
        backgroundColor: theme.palette.primary.dark,
        borderColor:theme.palette.primary.dark,
        cursor:'pointer',
        '&:hover':{
            backgroundColor:'transparent'
        }
    }
}));

const SingleChallegeComponent = (props) =>{
    // console.log("🚀 ~ SingleChallegeComponent ~ props:", props.passAllDataToDetails)
    const classes = useSingleChallegeComponentStyles();
    const {redirectLinkId,challengeTitle,ideaSubmitted,challengeOwner,submissionsEnd,category,passAllDataToDetails,onEditClick,onlyAdminEdit} = props || {}
    const ROUTES = NavigationService.getRoutes()
    const redirectChallengeDetailsPageURL = ROUTES[pages.DETAIL_CHALLENGE_INNOVATE].pathWithOutID ;
    

    return(
        <div className={classes.block}>
          
            <div className={classes.headingbox}>
                <div className={classes.headingIcon}><span><BsFlag /></span> </div>
                <p className={classes.textsmall}><span>Submitted</span> : <span>{ideaSubmitted} Ideas</span></p>
                <h3 className={classes.title}>{challengeTitle}</h3>
                <p className={classes.textsmall}><span>Challenge Owner</span> : {challengeOwner}</p>
                <p className={classes.textsmall}><span>Submissions End </span> : {submissionsEnd}</p>
                <p className={classes.textsmall}><span>Category </span> : {category}</p>
                <div className={classes.alignbtn}>
                <Link to={{
                  pathname:`${redirectChallengeDetailsPageURL}/${redirectLinkId}`,
                  state:{passAllDataToDetails}
                }} className={classes.selectbtn} 
                >
                    {/* <button type='button' onClick={()=>{}} > */}
                      View Details
                      {/* </button> */}
                  </Link>
                  {/* <Link></Link> */}
                  {
                    onlyAdminEdit ? (<button type='button' onClick={()=>onEditClick(redirectLinkId)} className={classes.selectbtn}> Edit </button>) : null
                  }
                    
                </div>
            </div>
         
        </div>
    )
}

